var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8752 7.67267L17.5121 1.03577M13.0875 1.03577H17.5121V5.46037M17.5121 10.7699V15.1945C17.5121 15.6639 17.3256 16.1141 16.9937 16.446C16.6618 16.7779 16.2116 16.9643 15.7422 16.9643H3.35334C2.88395 16.9643 2.43378 16.7779 2.10187 16.446C1.76996 16.1141 1.5835 15.6639 1.5835 15.1945V2.80561C1.5835 2.33622 1.76996 1.88605 2.10187 1.55414C2.43378 1.22223 2.88395 1.03577 3.35334 1.03577H7.77794",
    stroke: "white",
    strokeWidth: 1.76984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.bfc1733a48f837c71fb9463fc81d6bb7.svg";
export { ForwardRef as ReactComponent };